// Tiny NDJSON line-by-line parser for `fetch().body` ReadableStreams.
//
// The server emits one JSON object per `\n`-terminated line.  We buffer the
// tail of each chunk so a JSON object split across chunk boundaries is still
// parsed correctly.  Malformed lines are logged + skipped (we never throw
// from inside the loop — the caller relies on `done`/`error` *events* from
// the stream itself, not transport errors).

export async function* parseNdjsonStream<T = unknown>(
  body: ReadableStream<Uint8Array>,
): AsyncGenerator<T, void, void> {
  const reader = body.getReader()
  const decoder = new TextDecoder('utf-8')
  let buf = ''
  try {
    while (true) {
      const { value, done } = await reader.read()
      if (done) {
        const tail = buf.trim()
        if (tail) {
          try {
            yield JSON.parse(tail) as T
          } catch (err) {
            console.warn('[ndjson] dropping malformed tail line:', tail, err)
          }
        }
        return
      }
      buf += decoder.decode(value, { stream: true })
      let nl: number
      while ((nl = buf.indexOf('\n')) >= 0) {
        const line = buf.slice(0, nl).trim()
        buf = buf.slice(nl + 1)
        if (!line) continue
        try {
          yield JSON.parse(line) as T
        } catch (err) {
          console.warn('[ndjson] dropping malformed line:', line, err)
        }
      }
    }
  } finally {
    reader.releaseLock()
  }
}
